import { User } from 'oidc-client-ts';
import { cognitoUserManager } from '@/config/authConfig';
import { showError } from '@/shared';
import { ApiService } from './api.service';
import type { ChurchAdminSearchItem } from '@/types';

class UsersService extends ApiService {
  getUser = async (): Promise<User | null> => {
    try {
      return await cognitoUserManager.getUser();
    } catch (e) {
      showError(e);
      return null;
    }
  };

  lookupByEmail = async (email: string): Promise<ChurchAdminSearchItem[]> => {
    try {
      const url = `/api/v1/church-admins/search?email=${encodeURIComponent(email)}`;
      const response = await this.get<ChurchAdminSearchItem[]>(url);
      return response.data || [];
    } catch (e) {
      showError(e);
      return [];
    }
  };

  searchChurchAdmins = async (term: string): Promise<ChurchAdminSearchItem[]> => {
    try {
      const encodedTerm = encodeURIComponent(term);
      const url = `/api/v1/church-admins/search?email=${encodedTerm}`;
      const response = await this.get<ChurchAdminSearchItem[]>(url);
      return response.data || [];
    } catch (e) {
      showError(e);
      return [];
    }
  };
}

export default new UsersService();
